/**
 * Stub Fase 2 — motor de sincronización espacio-temporal.
 * En Fase 1 no escucha el viewport; solo guarda sesión y devuelve alignment vacío.
 */
import { resolveDeviceType } from './deviceCapability'

/**
 * @typedef {Object} SpatialMapperSession
 * @property {string} [study_instance_uid]
 * @property {string} [series_uid]
 * @property {import('./types').DeviceType} [device_type]
 */

export class AudioSpatialMapper {
  constructor() {
    /** @type {SpatialMapperSession|null} */
    this._session = null
    /** @type {number} */
    this._t0 = 0
    /** @type {import('./types').AlignmentEvent[]} */
    this._events = []
    /** @type {boolean} */
    this._active = false
  }

  /**
   * @param {SpatialMapperSession} [session]
   */
  start(session = {}) {
    this._session = {
      study_instance_uid: session.study_instance_uid || '',
      series_uid: session.series_uid || '',
      device_type: session.device_type || resolveDeviceType(),
    }
    this._t0 = typeof performance !== 'undefined' ? performance.now() : Date.now()
    this._events = []
    this._active = true
  }

  /**
   * Reserva API Fase 2: registrar un ping viewport (no-op en Fase 1 salvo buffer).
   * @param {Partial<import('./types').AlignmentEvent>} event
   */
  pushEvent(event) {
    if (!this._active || !event) return
    const now = typeof performance !== 'undefined' ? performance.now() : Date.now()
    const timestamp_sec =
      event.timestamp_sec != null
        ? Number(event.timestamp_sec)
        : Math.max(0, (now - this._t0) / 1000)
    this._events.push({
      timestamp_sec,
      slice_index: event.slice_index,
      series_uid: event.series_uid,
      image_position_patient_z: event.image_position_patient_z,
      viewport: event.viewport,
    })
  }

  stop() {
    this._active = false
  }

  /**
   * @returns {import('./types').AlignmentPayload}
   */
  getAlignment() {
    const s = this._session || {}
    return {
      device_type: s.device_type || resolveDeviceType(),
      study_instance_uid: s.study_instance_uid || undefined,
      series_uid: s.series_uid || undefined,
      events: this._events.slice(),
    }
  }

  reset() {
    this._session = null
    this._events = []
    this._active = false
    this._t0 = 0
  }
}

/** Instancia compartida para el ciclo de grabación de App. */
export const audioSpatialMapper = new AudioSpatialMapper()

export default audioSpatialMapper
